import { Component, OnInit } from '@angular/core';
import { ApiService } from '@anadolu-commons/tohum-ui';


@Component({
  templateUrl: './ana-sayfa.component.html',
  styles: []
})
export class AnaSayfaComponent implements OnInit {

  constructor(private apiService: ApiService) { }

  ngOnInit() {
  }

}
